import { render } from "./product-single-feature.vue?vue&type=template&id=6a8dcd1f"
import script from "./product-single-feature.vue?vue&type=script&lang=js"
export * from "./product-single-feature.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__